const ROOT_API = '/alx-admin';
const ROOT_URL = `${ROOT_API}/files/json`;

export const ServicesUrl = {
    versions: `${ROOT_URL}/versions.json`,
    whoWeAre: `${ROOT_URL}/whoWeAre.json`,
    partners: `${ROOT_URL}/partners.json`,
    news: `${ROOT_URL}/news.json`,
    popups: `${ROOT_URL}/popups.json`,
    news2: `${ROOT_URL}/news2.json`,
    casinos: `${ROOT_URL}/casinos.json`,
    magazine: `${ROOT_URL}/magazine.json`,
    commissions: `${ROOT_URL}/commissions.json`,
    blog: `${ROOT_API}/blog_posts`,
    blogComments: `${ROOT_API}/comments`,
}